import { render, staticRenderFns } from "./UpdateCompetences.vue?vue&type=template&id=2f65293a&scoped=true"
import script from "./UpdateCompetences.vue?vue&type=script&lang=js"
export * from "./UpdateCompetences.vue?vue&type=script&lang=js"
import style0 from "./UpdateCompetences.vue?vue&type=style&index=0&id=2f65293a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65293a",
  null
  
)

export default component.exports